import React, { Component } from "react";
import ApexCharts from 'apexcharts'

export default class Total extends Component {
    state = { chart: null }

    componentDidMount = () => {
        this.load();
    }

    load = () => {
        let value = this.props.value? this.props.value: 0;
        let options = {
            series: [this.props.percent],
            chart: {
                height: 200,
                type: 'radialBar',
                offsetY: -10
            },
            colors: ['#6c81e7'],
            tooltip: {
                enabled: true,
                style: {
                    backgroud: 'white',
                    fontSize: '12px',
                    fontFamily: undefined
                },
                y: {
                    formatter: (value) => { return value + "%" },
                }
            },
            plotOptions: {
                radialBar: {
                    // startAngle: -180,
                    // endAngle: 180,
                    dataLabels: {
                        name: {
                            fontSize: '14px',
                            offsetY: 85,
                            fontWeight: 400,
                            color:"#000"
                        },
                        value: {
                            offsetY: -10,
                            fontSize: '22px',
                            color: undefined,
                            formatter: function (val) {
                                return value;
                            }
                        }
                    }
                }
            },
           
            labels: ['Total Users'],
        }
        var chart = new ApexCharts(document.querySelector("#total"), options);
        chart.render();
        this.setState({ chart: chart })
    }

    componentDidUpdate = (prevProps) => {
		if(this.props.value !== prevProps.value){
			if(this.state.chart) this.state.chart.destroy();
			this.load();
		}
	}

    render() {
        return (
            <div id="total"></div>
        );
    }
}